module.exports = __webpack_public_path__ + "static/media/on.99bceb4d.svg";